import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Tooltips } from './Tooltips';
import { useTooltip } from './hooks';
import { Playground } from 'docz';
import { Text } from '../Typography';
import { WrapperVertical } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Component = makeShortcode("Component");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "tooltips"
    }}>{`Tooltips`}</h1>
    <p>{`Is a component that displays a tooltip when the user hovers over an element.`}</p>
    <h2 {...{
      "id": "tooltip-usage"
    }}>{`Tooltip usage`}</h2>
    <h3 {...{
      "id": "predisposition"
    }}>{`Predisposition`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Before usage, you need to wrap your `}<inlineCode parentName="p">{`App`}</inlineCode>{` in `}<inlineCode parentName="p">{`Tooltips`}</inlineCode>{` provider`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { Tooltips } from '@atlasgroup/react-atlantic';

// App.tsx
export const App = () => (
    <OtherProvider>
        <Tooltips>// Your app</Tooltips>
    </OtherProvider>
);
`}</code></pre>
    <h3 {...{
      "id": "then-you-are-set-to-go-for-specific-tooltip-usage"
    }}>{`Then you are set to go for specific tooltip usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { useTooltip, Text } from '@atlasgroup/react-atlantic';

export const Component = () => {
    const tooltip = useTooltip();
    return (
        <Text ref={tooltip} data-title="Text to display" data-position="left">
            Czech Republic🇨🇿
        </Text>
    );
};
`}</code></pre>
    <h2 {...{
      "id": "different-positions"
    }}>{`Different positions`}</h2>
    <Playground __position={0} __code={'() => {\n  const Component = () => {\n    const tooltip = useTooltip()\n    return (\n      <WrapperVertical>\n        <Text ref={tooltip} data-title=\"Left\" data-position=\"left\">\n          Hover over me 👋🏻\n        </Text>\n        <Text ref={tooltip} data-title=\"Right\" data-position=\"right\">\n          Hover over me 👋🏼\n        </Text>\n        <Text ref={tooltip} data-title=\"Top\" data-position=\"top\">\n          Hover over me 👋🏾\n        </Text>\n        <Text ref={tooltip} data-title=\"Bottom\" data-position=\"bottom\">\n          Hover over me 👋🏿\n        </Text>\n      </WrapperVertical>\n    )\n  }\n  return (\n    <Tooltips>\n      <Component />\n    </Tooltips>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Tooltips,
      useTooltip,
      Playground,
      Text,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const Component = () => {
          const tooltip = useTooltip();
          return <WrapperVertical mdxType="WrapperVertical">
                    <Text ref={tooltip} data-title="Left" data-position="left" mdxType="Text">
                        Hover over me 👋🏻
                    </Text>
                    <Text ref={tooltip} data-title="Right" data-position="right" mdxType="Text">
                        Hover over me 👋🏼
                    </Text>
                    <Text ref={tooltip} data-title="Top" data-position="top" mdxType="Text">
                        Hover over me 👋🏾
                    </Text>
                    <Text ref={tooltip} data-title="Bottom" data-position="bottom" mdxType="Text">
                        Hover over me 👋🏿
                    </Text>
                </WrapperVertical>;
        };

        return <Tooltips mdxType="Tooltips">
                <Component mdxType="Component" />
            </Tooltips>;
      }}
    </Playground>
    <h2 {...{
      "id": "tooltips-provider-props"
    }}>{`Tooltips provider props`}</h2>
    <h3 {...{
      "id": "hidetooltips"
    }}>{`hideTooltips`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can hide the tooltips globally by passing `}<inlineCode parentName="p">{`hideTooltip`}</inlineCode>{` prop to `}<inlineCode parentName="p">{`Tooltips`}</inlineCode>{` provider`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Tooltips hideTooltips={true}>{/*Component*/}</Tooltips>
`}</code></pre>
    <h3 {...{
      "id": "contentattr"
    }}>{`contentAttr`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can also pass `}<inlineCode parentName="p">{`contentAttr`}</inlineCode>{` & `}<inlineCode parentName="p">{`positionAttr`}</inlineCode>{` props to the `}<inlineCode parentName="p">{`Tooltips`}</inlineCode>{` provider to change the `}<inlineCode parentName="p">{`content`}</inlineCode>{` and `}<inlineCode parentName="p">{`position`}</inlineCode>{` attribute of tooltips respectivelly`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Tooltips contentAttr="data-content" positionAttr="data-place">
    {/*Component*/}
</Tooltips>
`}</code></pre>
    <h3 {...{
      "id": "tooltip"
    }}>{`Tooltip`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Last but not least, you can pass `}<inlineCode parentName="p">{`Tooltip`}</inlineCode>{` prop to the `}<inlineCode parentName="p">{`Tooltips`}</inlineCode>{` provider to change the component used for tooltips`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const StyledTooltip = styled.div\`
    color: red;
\`;

<Tooltips Tooltip={StyledTooltip}>{/*Component*/}</Tooltips>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      